var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"beta-chip ml-2",attrs:{"x-small":"","label":"","outlined":"","color":"primary","data-testid":"beta-chip"}},[_vm._v(" "+_vm._s(_vm.$t("common.beta"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }